import { Image } from "#components/Image";
import { Grid } from "@chakra-ui/react";

import InfoYellow from "./info-yellow.svg";
import Info from "./info.svg";
import LeftTurn from "./left-turn.svg";
import NoLeftTurn from "./no-left-turn.svg";
import No from "./no.svg";
import Rest from "./rest.svg";

export const Fig1 = () => {
  return (
    <Grid justifyContent="center" templateColumns="repeat(3, 4.5em)" gap="3">
      <Image src={NoLeftTurn} />
      <Image src={No} />
      <Image src={LeftTurn} />
    </Grid>
  );
};

export const Fig2 = () => {
  return (
    <Grid justifyContent="center" templateColumns="repeat(1, 10em)">
      <Image src={Rest} />
    </Grid>
  );
};

export const Fig3 = () => {
  return (
    <Grid
      justifyContent="center"
      justifyItems="center"
      templateColumns="repeat(2, 5em)"
    >
      <Image src={Info} />
      <Image src={InfoYellow} />
    </Grid>
  );
};
